import React from 'react'
import { useLoaderData } from 'react-router-dom'
import { VscDebugBreakpointLogUnverified } from "react-icons/vsc";
import { IoArrowRedoOutline } from "react-icons/io5";
import useTitle from './../../hooks/UseTitle';
function Detail() {
  useTitle('Details')
  const projectsDetail = useLoaderData();
  const{title,img,description,LiveSite,details,client,technology,backend,tools} =  projectsDetail;
  console.log('data',projectsDetail);
  return (
    <div className='min-h-screen max-w-screen-xl mx-auto' >
        <h2 className="font-bold text-4xl md:text-7xl  lg:text-[120px] text-gray-300 opacity-[0.3] text-center m-auto animate-pulse py-4 numb">PROJECT DETAILS</h2>
       <div  className="text-center absolute md:top-[3%] lg:top-[8%] top-[2%] md:left-[37%] lg:left-[42%] left-[28%]">
       <h2 data-aos="fade-up" className=" font-bold text-xl md:text-4xl text-neutral " >SEE PROJECT DETAILS</h2>
       </div>
      <div className='grid md:grid-cols-2 items-center' >
        <div className='card p-5 rounded-none '  >
        <div data-aos="zoom-in-up" className='w-full h-[500px] overflow-auto touch-auto border-l border-b-2 p-5' style={{ boxShadow: "inset -2px 0px 6px #70acc7" }}>
  <img className='w-full h-auto' src={img} alt="" />
      </div>
    

      <div className='my-5'>
      <div className='md:flex gap-4 justify-center grid grid-cols-2'>
     <a href={client} style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='btn rounded-none border-2 bg-transparent hover:bg-transparent hover:shadow-md shadow-lg'> Client Side</a>
     <a href={client} style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='btn rounded-none border-2 bg-transparent hover:bg-transparent hover:shadow-md shadow-lg'> Server Side</a>
       <a href={LiveSite} style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='btn rounded-none border-2 bg-transparent hover:bg-transparent hover:shadow-md shadow-lg'> Live Website </a>
     </div>
      </div>
        </div>

        {/* description */}
        <div className='m-auto p-5 md:mt-8 border-dashed border-neutral md:border-l'>
          <h2 className='text-xl text-neutral font-bold'>{title}</h2>
          <p className='text-justify mt-4' data-aos="fade-right"><span className='font-bold mr-2 text-neutral'>Overview:</span>{description}</p>

          <div>
            <h2 className='flex gap-3 mt-4 text-xl  font-extrabold animate-pulse'><IoArrowRedoOutline className='text-2xl text-neutral '></IoArrowRedoOutline> Features:</h2>
          </div>
          <div className='mt-4 ' data-aos="fade-left">
          {details.map((d, i) => (
              <>
              <p className="flex gap-2 my-2" key={i}>
             
                < VscDebugBreakpointLogUnverified className='text-2xl self-center text-neutral'></ VscDebugBreakpointLogUnverified>{d}
              </p>
              </>
            ))}
             </div>
             <div>
             <h2 className='flex gap-3 mt-4 text-xl  font-extrabold animate-pulse'><IoArrowRedoOutline className='text-2xl text-neutral '></IoArrowRedoOutline> Tech Stack:</h2>
             <div>
                <h1 className='font-extrabold text-neutral my-3 text-xl'>Fronted:</h1>
                <div className='grid lg:grid-cols-4 grid-cols-3 gap-5  text-xs ' data-aos="fade-up">
                {/* <h2 style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='hover:scale-110 duration-500 ease-in-out  btn btn-sm rounded-none border-2 bg-transparent hover:bg-neutral hover:text-white shadow-lg'>{f1}</h2> */}
                
                {technology.map((t, i) => (
             
              <div className="self-center  " key={i}>
              <h2 style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='hover:scale-110 duration-500 capitalize text-center ease-in-out  border-neutral p-[10px]  rounded-none border-2 bg-transparent hover:bg-neutral hover:text-white shadow-lg'>  {t}</h2>
             
              </div>
            
            ))}
                
                </div>
             </div>

             <div>
             <h1 className='font-extrabold text-neutral my-3 text-xl'>Backend:</h1>
            <div className='grid lg:grid-cols-4 grid-cols-3 gap-5  text-xs ' data-aos="fade-right">
                {/* <h2 style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='hover:scale-110 duration-500 ease-in-out  btn btn-sm rounded-none border-2 bg-transparent hover:bg-neutral hover:text-white shadow-lg'>{f1}</h2> */}
                
                {backend.map((b, i) => (
             
              <div className="self-center  " key={i}>
              <h2 style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='hover:scale-110 duration-500 capitalize text-center ease-in-out  border-neutral p-[10px]  rounded-none border-2 bg-transparent hover:bg-neutral hover:text-white shadow-lg'>  {b}</h2>
             
              </div>
            
            ))}
                
                </div>
             </div>

             <div>
             <h1 className='font-extrabold text-neutral my-3 text-xl'>Tools:</h1>
             <div className='grid lg:grid-cols-4 grid-cols-3 gap-5  text-xs ' data-aos="fade-up">
                {/* <h2 style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='hover:scale-110 duration-500 ease-in-out  btn btn-sm rounded-none border-2 bg-transparent hover:bg-neutral hover:text-white shadow-lg'>{f1}</h2> */}
                
                {tools.map((t, i) => (
             
              <div className="self-center  " key={i}>
              <h2 style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className='hover:scale-110 duration-500 capitalize text-center ease-in-out  border-neutral p-[10px]  rounded-none border-2 bg-transparent hover:bg-neutral hover:text-white shadow-lg'>  {t}</h2>
             
              </div>
            
            ))}
                
                </div>
             </div>
             </div>
        </div>

      </div>

      <div className='py-16 md:visible invisible'></div>
    </div>
  )
}

export default Detail
